// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"app-2ysNJCkv","links":"app-2hoVRsbr","copyright":"app-3jkg_Jhv"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/globalFooter/index.less
// module id = 467
// module chunks = 0